export default __webpack_public_path__ + "static/background_footer-6779acd79762b9237b3d7b0cd3b59426.png";